import { render, staticRenderFns } from "./SelectCoverage.vue?vue&type=template&id=c67dd38a&scoped=true&"
import script from "./SelectCoverage.vue?vue&type=script&lang=js&"
export * from "./SelectCoverage.vue?vue&type=script&lang=js&"
import style0 from "./SelectCoverage.vue?vue&type=style&index=0&id=c67dd38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67dd38a",
  null
  
)

export default component.exports